import React from 'react';
import CloseBadge from '../Utilities/CloseBadge';

export default function PendingAttachment({ children, onClose }: { children: JSX.Element; onClose: () => void }) {
    return <CloseBadge onClose={onClose}>{children}</CloseBadge>;
}
